import i18n from '@/i18n'
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AboutUsView from '../views/AboutUsView.vue'
import ContactView from '../views/ContactView.vue'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { titleKey: 'nav.home' },
  },
  {
    path: '/about',
    name: 'about',
    component: AboutUsView,
    meta: { titleKey: 'nav.about' },
  },
  {
    // New Contact Route
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: { titleKey: 'nav.contact' },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  },
})

router.beforeEach((to, from, next) => {
  const titleKey = to.meta.titleKey as string
  if (titleKey) {
    document.title = `${i18n.global.t(titleKey)} - toruk MAGIC™ Deep Tech`
  } else {
    document.title = 'toruk MAGIC™ Deep Tech'
  }
  document.documentElement.lang = i18n.global.locale
  next()
})

export default router
